import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

export const GenericSectionStyle = styled.div`
  .title:first-letter {
    text-transform: capitalize;
  }
  fieldset { 
    border: 0
  }
  .generic-wrapper {
    background: ${theme.primaryColours.white.main};
    border-radius: ${theme.grid.spacing.xs}px;
    padding: ${theme.grid.spacing.base}px;
    margin: ${theme.grid.spacing.s}px 0 ${theme.grid.spacing.md}px;
    &.no-padding {
      padding: 0;
    }
    &.convictions {
      .additional-button {
        margin-bottom: ${theme.grid.spacing.base}px;
      }
    }
  }

  .question-container {
    &:not(:last-child) {
      margin-bottom: ${theme.grid.spacing.base}px;
    }
  }
  .question-text-container {
    margin-bottom: ${theme.grid.spacing.s}px;
  }

  .question-info {
    color: ${theme.primaryColours.aubergine.main};
    margin-top: ${theme.grid.spacing.xxs}px;
  }
  .input-info-container {
    display: flex;
    align-items: baseline;
  }
  .address-text-container {
    margin-bottom: ${theme.grid.spacing.base}px;
  }
  .modal-link {
    text-decoration: underline;
    cursor: pointer;
  }
  .tool-tip {
    margin-left: ${theme.grid.spacing.s}px;
  }
  .tip-top-xs {
    top: 4px;
  }
  .tip-top-small {
    top: 4px;
  }
  .tip-top-medium {
    top: 6px;
  }
  .tool-align-center {
    top: 54px;
  }
  .max-width {
    width: 254px;
  }
  .dropdown-top-heaven {
    z-index: 16;
  }
  .dropdown-top-top {
    z-index: 15;
  }
  .dropdown-top,
  .autocomplete-top {
    z-index: 14;
  }
  .dropdown-above,
  .autocomplete-above {
    z-index: 13;
  }
  .dropdown-middle,
  .autocomplete-middle {
    z-index: 12;
  }
  .dropdown,
  .autocomplete {
    z-index: 11;
  }
  .dropdown-bellow,
  .autocomplete-bellow {
    z-index: 10;
  }
  .dropdown-bottom, 
  .autocomplete-bottom {
    z-index: 9;
  }

  .modal-title {
    margin: ${theme.grid.spacing.s}px 0 ${theme.grid.spacing.base}px;
  }

  .page-level-error {
    position: relative;
    width: 100%;
  }

  .additonal-wrapper {
    background-color: ${theme.tints.lightAubergine};
    padding: ${theme.grid.spacing.base}px;
    max-width: 390px;

    .attribute-box {
      &:not(:last-child) {
        border-bottom: 1px solid ${theme.tints.aubergine};
        padding-bottom: ${theme.grid.spacing.base}px;
        margin-bottom: ${theme.grid.spacing.base}px;
      }
    }
  }
  .additional-button {
    margin-top: ${theme.grid.spacing.base}px;
    .icon__plus-small svg {
        margin-top: 0;
        background-color: ${theme.primaryColours.mint.superDarkMint};
        border-radius: 50%;
      }
    }
  }

  .auto-complete-input {
    ul {
      z-index: 19;
    }
  }
  .input-info-container {
    &.months-input {
      max-width: 196px;
      div {
        max-width: 100%;
      }
      .input-wrapper {
        max-width: 100%;
      }
      .error-message {
        width: 100%;
        p {
          width: 100%;
        }
      }
    }
  }
  .icon__plus-small {
    margin-top: 0 !important;
  }

  @media (max-width: 468px) {
    .input-info-container {
      .input-input {
        width: 100%;
        .input-wrapper {
          width: 100%;
        }
      }
    }
  }

  @media (min-width: 468px) {
    .input-info-container {
      .input-input {
        width: 350px;
        .input-wrapper {
          width: 350px;
        }
      }
    }
  }

  @media (min-width: ${theme.grid.resolution.mobile.width}px) {
    .generic-wrapper {
      padding: ${theme.grid.spacing.md}px;
    }

    .question-container {
      &:not(:last-child) {
        margin-bottom: ${theme.grid.spacing.md}px;
      }
    }
    .max-width {
      width: 388px;
    }
    .dropdown-large-with-icon {
      max-width: 350px;
    }
    .dropdown-medium-with-icon {
      max-width: 240px;
    }
    .dropdown-small-with-icon {
      max-width: 160px;
    }
    .dropdown-small {
      max-width: 200px;
    }
    .additional-modal-button-container {
      .button-add {
        margin-right: ${theme.grid.spacing.base}px;
      }
    }
  }

  @media (max-width: ${theme.grid.resolution.tablet.width}px) {
    .additional-modal-button-container {
      display: flex;
      flex-direction: column;
      .button-add {
        margin: 0 0 ${theme.grid.spacing.s}px 0;
      }
    }
    .attribute-actions {
      .button {
        padding: ${theme.grid.spacing.s}px ${theme.grid.spacing.base}px 
      }
    }
    .additonal-wrapper {
      padding: ${theme.grid.spacing.s}px;
      max-width: 280px;
    }
  }

@media (max-width: ${theme.grid.resolution.tablet.width}px) {
  @supports (-webkit-text-size-adjust:none) and (not (-ms-ime-align:auto))
and (not (-moz-appearance:none)) {
  .auto-convictions-wrapper .auto-complete-input{
    position: relative !important;
  }
}


`
